import * as React from 'react';
export default /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js
// module id = 924
// module chunks = 0